var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiplomaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.83333H10.3333V4.16667C10.3333 3.798 10.0353 3.5 9.66667 3.5H5.66667C5.298 3.5 5 3.798 5 4.16667V4.83333H4.33333C3.59733 4.83333 3 5.43067 3 6.16667V16.1667C3 16.9027 3.59733 17.5 4.33333 17.5H15C15.736 17.5 16.3333 16.9027 16.3333 16.1667V6.16667C16.3333 5.43067 15.736 4.83333 15 4.83333ZM6.33333 4.83333H9V10.5573L8.138 9.69533C8.008 9.56533 7.83733 9.5 7.66667 9.5C7.496 9.5 7.32533 9.56533 7.19533 9.69533L6.33333 10.5573V4.83333ZM14.998 16.1667H4.33333V6.16667H5V12.1667C5 12.436 5.16267 12.68 5.41133 12.7827C5.66067 12.8853 5.94667 12.8287 6.138 12.638L7.66667 11.1093L9.19533 12.638C9.32267 12.7653 9.49333 12.8333 9.66667 12.8333C9.75267 12.8333 9.83933 12.8167 9.922 12.7827C10.1707 12.68 10.3333 12.436 10.3333 12.1667V6.16667H15L14.998 16.1667Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 7.5H11V8.83333H13.6667V7.5Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 9.5H11V10.8333H13.6667V9.5Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 11.5H11V12.8333H13.6667V11.5Z",
    fill: "#959595"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 13.5H5.66602V14.8333H13.666V13.5Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiplomaIcon);
export default __webpack_public_path__ + "static/media/DiplomaIcon.cbebb5cce48fabde5f6a621a4d959439.svg";
export { ForwardRef as ReactComponent };